// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"09f0e105","193":"41386fef","782":"c19a72b8"}[chunkId] + ".chunk.js";
};